interface HourglassEmptyIconProps {
  className?: string
}

export default function HourglassEmptyIcon({
  className,
}: HourglassEmptyIconProps) {
  return (
    <svg
      viewBox="0 0 64 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Sand in top bulb - drains over time */}
      <path
        d="M14 12 L14 22 Q14 32 32 42 Q50 32 50 22 L50 12 Z"
        fill="currentColor"
        opacity="0.3"
        className="hourglass-sand-top"
      />

      {/* Sand stream through neck */}
      <line
        x1="32"
        y1="42"
        x2="32"
        y2="54"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.3"
        className="hourglass-stream"
      />

      {/* Sand in bottom bulb - fills over time */}
      <path
        d="M14 84 L14 74 Q14 64 32 54 Q50 64 50 74 L50 84 Z"
        fill="currentColor"
        opacity="0.3"
        className="hourglass-sand-bottom"
      />

      {/* Top frame */}
      <path
        d="M8 8 L56 8"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        className="empty-state-draw"
      />

      {/* Top glass bulb - left side */}
      <path
        d="M12 8 L12 24 Q12 36 32 44"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="empty-state-draw-delayed"
      />

      {/* Top glass bulb - right side */}
      <path
        d="M52 8 L52 24 Q52 36 32 44"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="empty-state-draw-delayed"
      />

      {/* Bottom glass bulb - left side */}
      <path
        d="M32 52 Q12 60 12 72 L12 88"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="empty-state-draw-delayed-2"
      />

      {/* Bottom glass bulb - right side */}
      <path
        d="M32 52 Q52 60 52 72 L52 88"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="empty-state-draw-delayed-2"
      />

      {/* Bottom frame */}
      <path
        d="M8 88 L56 88"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        className="empty-state-draw-delayed-2"
      />

      {/* Center neck - subtle narrowing */}
      <path
        d="M28 46 L28 50 M36 46 L36 50"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="empty-state-draw-delayed"
      />

      {/* Decorative top caps */}
      <path
        d="M6 6 L58 6 M6 10 L8 10 M56 10 L58 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="empty-state-draw"
      />

      {/* Decorative bottom caps */}
      <path
        d="M6 90 L58 90 M6 86 L8 86 M56 86 L58 86"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="empty-state-draw-delayed-2"
      />
    </svg>
  )
}
